import { FC } from 'react';
import { ContentLoader } from '@edikk-edikk/country-common';
import { useAdvertListContext } from '#advertList/hooks';
import { CatalogByServiceItem } from '#advertList/components/catalog-by-service/CatalogByServiceItem';
import catalogByServiceCss from '#srcCssModules/advert/catalog/catalog-by-service.module.scss';
import { useBaseContext } from '#base/hooks/use-base-context';
import { CatalogMode } from '#advert/components/card-list';
import catalogLoaderCss from '#advertList/assets/catalog-loader.module.scss';

const CatalogByService: FC = () => {
  const { catalogMode } = useBaseContext();
  const { advertDataListByService, isFetching } = useAdvertListContext();

  if (catalogMode !== CatalogMode.groupingService) {
    return null;
  }

  if (isFetching) {
    return <ContentLoader additionalClassName={catalogLoaderCss.catalogLoader} />;
  }

  const catalogElementList = advertDataListByService.chunkDataList.map((chunk) => (
    <CatalogByServiceItem key={chunk.serviceId} chunk={chunk} />
  ));

  return (
    <div className={catalogByServiceCss.catalogByService}>
      {catalogElementList}
    </div>
  );
};

export { CatalogByService };
